import { useState } from "react";
import { C } from "../constants";
import { Modal, Btn, iStyle, lblSt } from "./ui";

export const ProgramBuilder = ({ program, onSave, onClose }) => {
  const [name,  setName]  = useState(program?.name  || "");
  const [emoji, setEmoji] = useState(program?.emoji || "🔄");

  const submit = () => {
    if (!name.trim()) return;
    onSave({ ...program, id: program?.id || Date.now(), name: name.trim(), emoji, plans: program?.plans || [] });
    onClose();
  };

  return (
    <Modal onClose={onClose} title={program ? "Edit Program" : "New Program"}>
      <div style={{ display: "flex", gap: 10, marginBottom: 20 }}>
        <div>
          <label style={lblSt}>Emoji</label>
          <input value={emoji} onChange={e => setEmoji(e.target.value)}
            style={{ ...iStyle, width: 60, textAlign: "center", fontSize: 20 }} maxLength={2} />
        </div>
        <div style={{ flex: 1 }}>
          <label style={lblSt}>Program Name</label>
          <input placeholder="e.g. Push Pull Legs" value={name} onChange={e => setName(e.target.value)} style={iStyle} />
        </div>
      </div>
      <div style={{ padding: "12px 14px", background: C.surface, borderRadius: 9, marginBottom: 18, fontSize: 13, color: C.muted, lineHeight: 1.5 }}>
        A program groups your workout days into a rotation. You can add individual workout plans to it after creating it.
      </div>
      <Btn variant="primary" onClick={submit} style={{ width: "100%", padding: "13px 0", fontSize: 15 }}>
        {program ? "Save Program" : "Create Program"}
      </Btn>
    </Modal>
  );
};
